module.exports = __webpack_public_path__ + "img/1746604883_kVv6.9ec09be2.jpg";